<template>
  <div class="faq-container">
    <header class="faq-header">
      <h1>常见问题</h1>
      <p class="contact-prompt">如果在阅读完本页面后你仍然有问题，欢迎 <router-link to="/contact">联系我们</router-link>。</p>
    </header>

    <main class="faq-content">
      <div class="faq-item" v-for="(item, index) in faqs" :key="index">
        <h2 class="question" @click="toggleAnswer(index)">
          <span class="q-mark">Q:</span> {{ item.question }}
          <span class="toggle-icon">{{ activeIndex === index ? '−' : '+' }}</span>
        </h2>
        <div class="answer" v-show="activeIndex === index" v-html="item.answer"></div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: 'FAQ',
  data() {
    return {
      activeIndex: null,
      faqs: [
        {
          question: "谁可以发表点评？",
          answer: `本网站是专门为研究生评价导师而设计的。我们欢迎任何在导师实验室里做过科研的小伙伴分享他们对导师的了解。如果你仅仅上过教授的课程，我们不鼓励你在本网站撰写点评。`
        },
        {
          question: "当导师被添加到Half Panda时，他们会收到电子邮件通知吗？",
          answer: "不会。当导师被添加到Half Panda、或者有关他们的点评被撰写时，我们不会以任何方式通知该导师。"
        },
        {
          question: "导师被添加Half Panda后会发生什么？",
          answer: `当您将一个导师添加到我们的Half Panda后，网站上的其他用户将能够看到该导师的信息，并可以对其进行点评。您的用户名和密码将被用于登录网站，并用于访问您的个人信息和评论。`
        },
        {
          question: "在某些情况下，Half Panda会与导师分享用户信息吗？",
          answer: `不会。我们非常重视用户的个人信息，仅收集密码和邮箱。我们不会与任何第三方分享用户信息，也不会在任何情况下向导师透露用户信息。我们致力于尽最大努力保护我们用户的个人信息。`
        },
        {
          question: "我如何在Half Panda上撰写评论时保护我的个人信息？",
          answer: `首先，您可以匿名发表评论，这样您的用户名不会显示在评论中。其次，请谨慎选择在评论中包含的信息，因为导师可能会根据内容确定作者身份。比如，分享客观事实比个人故事更安全。我们的导师评价表为评论导师的各个方面提供了建议性问题，回答这些问题相对安全。`
        },
        {
          question: "为什么我添加的导师没有公开？为什么导师页面只对我可见？为什么搜不到我添加的导师？",
          answer: `如果你本站搜索不到你刚刚添加的导师，那意味着你添加的导师还没有被审核通过。本站的管理员会审核你添加的导师信息，确认无误后会通过你的添加请求。在导师信息通过审核之前，只有你自己可以看到该导师，你可以在账号->已添加导师页面找到该导师。值得注意的时候，尽管导师信息没有公开，你已经可以给刚添加的导师写点评了。你的点评会在导师信息通过审核后一起对外可见。`
        },
        {
          question: "搜索不到我的学校",
          answer: `如果你在学校的搜索框中找不到你的学校，可以创建导师，并在创建过程中选择你的学校。学校，学院会和导师一并创建！`
        },
        {
          question: "为什么我的点评被隐藏了？谁隐藏了我的点评？",
          answer: `如果你的点评违反了本网站的 <router-link to="/terms">使用条款</router-link>，管理员会将你的点评Half Panda上隐藏。如果你对此有疑异，请邮件联系我们。`
        },
      ]
    }
  },
  methods: {
    toggleAnswer(index) {
      this.activeIndex = this.activeIndex === index ? null : index
    }
  }
}
</script>

<style scoped>
.faq-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: 'Arial', sans-serif;
  line-height: 1.6;
  color: #333;
}

.faq-header {
  text-align: center;
  margin-bottom: 30px;
  padding-bottom: 15px;
  border-bottom: 1px solid #eee;
}

.faq-header h1 {
  font-size: 28px;
  color: #2c3e50;
  margin-bottom: 10px;
}

.contact-prompt {
  font-size: 16px;
  color: #7f8c8d;
}

.faq-content {
  margin-bottom: 30px;
}

.faq-item {
  margin-bottom: 15px;
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}

.faq-item:last-child {
  border-bottom: none;
}

.question {
  font-size: 18px;
  color: #2c3e50;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px 0;
  margin: 0;
  transition: color 0.2s;
}

.question:hover {
  color: #3498db;
}

.q-mark {
  color: #e74c3c;
  font-weight: bold;
  margin-right: 8px;
}

.toggle-icon {
  margin-left: auto;
  font-size: 20px;
  font-weight: bold;
  color: #7f8c8d;
}

.answer {
  padding: 10px 0 10px 25px;
  font-size: 15px;
  color: #34495e;
  animation: fadeIn 0.3s ease-in-out;
}

.answer >>> a {
  color: #3498db;
  text-decoration: none;
}

.answer >>> a:hover {
  text-decoration: underline;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .faq-container {
    padding: 15px;
  }

  .question {
    font-size: 16px;
  }

  .answer {
    font-size: 14px;
  }
}
</style>